function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  #gradi{fill:url(#MyGradient)}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "MyGradient",
  gradientTransform: "rotate(65)"
}, ">\n    ", /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#107ff9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#2fb7ed"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "gradi"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M258.05,326.91c-1.54-14.85.59-29.84,3-40.88,9.59-10.13,17.8-25.21,26.27-49.1,12.75-4.67,25.69-15.47,31.7-42.07,2.77-12.25-2-23.58-10.35-31.74,6-20.21,29.73-113.88-41.49-132.87C243.5.64,222.77,1.82,187.25,5.38c-17.68,1.76-20.19,5.52-33.76,3.55-15.56-2.26-28.18-7-32-8.88C119.33-1,98.81,17.16,93.09,32,75,79.11,79.85,111.41,84.45,135.83c-.15,2.5-.36,5-.36,7.52l4.23,17.9c0,.18,0,.36,0,.54C79.14,170,73.6,181.92,76.53,194.86c6,26.62,19,37.41,31.72,42.08,8.46,23.86,16.66,38.94,26.24,49.07,2.42,11,4.56,26,3,40.91C131,389.19,0,356.39,0,465.73,0,482.59,56.51,512,197.78,512s197.78-29.41,197.78-46.27C395.56,356.39,264.52,389.19,258.05,326.91Z"
})));

var SvgFeature02 = function SvgFeature02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.56 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature02.7d82681d.svg";
export { ForwardRef as ReactComponent };